import { memo, useCallback, useRef } from 'react';
import { translate } from '../../utils';
import Button from '../Button';

export const AddGuestsPageActions = memo(function AddGuestsPageActions({
    onDownloadEmptyTemplate,
    onDownloadTemplateWithGuests,
    onUploadGuestsData,
}) {
    const uploadInputRef = useRef(null);

    const handleUploadGuestsData = useCallback(() => {
        uploadInputRef.current?.click();
    }, []);

    const handleUploadInputChange = useCallback((event) => {
        onUploadGuestsData(event);
        event.target.value = '';
    }, [onUploadGuestsData]);

    const handleDownloadTemplateWithGuestsClick = useCallback((event) => {
        event.preventDefault();
        onDownloadTemplateWithGuests();
    }, [onDownloadTemplateWithGuests]);

    return <div className="box box-solid">
        <div className="box-body btn-ribbon">
            <div className="btn-group">
                <Button type="button" className="btn btn-default" onClick={onDownloadEmptyTemplate}>
                    <i className="fa fa-arrow-down-to-bracket" />
                    {translate('frontend', 'ADD_GUESTS_DOWNLOAD_TEMPLATE')}
                </Button>

                <div className="btn-group">
                    <Button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown">
                        <span className="caret" />
                    </Button>

                    <ul className="dropdown-menu">
                        <li>
                            <a href="#" onClick={handleDownloadTemplateWithGuestsClick}>
                                {translate('frontend', 'ADD_GUESTS_DOWNLOAD_TEMPLATE_WITH_GUESTS')}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <Button type="button" className="btn btn-default" onClick={handleUploadGuestsData}>
                <i className="fa fa-arrow-up-from-bracket" />
                {translate('frontend', 'ADD_GUESTS_UPLOAD_GUESTS_DATA')}
            </Button>

            <input
                ref={uploadInputRef}
                type="file"
                accept=".csv,text/csv"
                style={{ display: 'none' }}
                onChange={handleUploadInputChange}
            />
        </div>
    </div>;
});
